import { render, staticRenderFns } from "./AuthorDetailView.vue?vue&type=template&id=ed821558&"
import script from "./AuthorDetailView.vue?vue&type=script&lang=js&"
export * from "./AuthorDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports